import { ENTITY_TYPE_PARENT } from './entity-designer.constants';

export const initialEntitySettings = {
  entityName: '',
  entityType: ENTITY_TYPE_PARENT,
  useGenericTable: true,
  tableName: '',
  runtimeTable: 'GBL_OBJ_INFO',
};

export const initialErrors = {
  entityName: { hasError: false, errorText: '' },
  tableName: { hasError: false, errorText: '' },
};
